import Immutable from 'immutable';
import { get } from 'lodash';
import { propertyListActionTypes } from '~constants/actionTypes';
import { defaultCommunicationObject, updateCommunicationObject } from '~reducers/shared';

export const defaultState = Immutable.fromJS({
  list: {
    payload: [],
    total: 0,
  },
  communication: defaultCommunicationObject,
});

const formatPayload = properties =>
  properties.map(property => ({
    id: get(property, 'node.id'),
    name: get(property, 'node.name'),
    slug: get(property, 'node.slug'),
    countryName: get(property, 'node.city.country.name'),
    averageRating: get(property, 'node.reviewsSummary.averageRating'),
    cityName: get(property, 'node.city.name'),
    landlordName: get(property, 'node.landlord.name'),
    status: get(property, 'node.status'),
    unpublishReason: get(property, 'node.unpublishReason'),
    updatedAt: get(property, 'node.updatedAt'),
    updatedBy: get(property, 'node.updatedByUser.name') || '',
    heroImage: get(property, 'node.heroImage') || {},
    state: get(property, 'node.state'),
    landlord: get(property, 'node.landlord'),
    bookingJourney: get(property, 'node.bookingJourney'),
    contracts: get(property, 'node.contracts'),
    contractStage: get(property, 'node.contractStage'),
    commissionTiers: get(property, 'node.commissionTiers'),
    withdrawMthod: get(property, 'node.withdrawMthod'),
    paymentPlan: get(property, 'node.paymentPlan'),
    publishCondition: get(property, 'node.publishCondition'),
    rankStarCn: get(property, 'node.profile.starCnValue'),
    rankStarRow: get(property, 'node.profile.starRowValue'),
    rankBlacksheepCn: get(property, 'node.profile.blacksheepCn'),
    rankBlacksheepRow: get(property, 'node.profile.blacksheepRow'),
    externalSystem: get(property, 'node.externalSystem'),
    externalId: get(property, 'node.externalId'),
  }));

const propertyListReducer = (state = defaultState, action) => {
  switch (action.type) {
    case propertyListActionTypes.INITIALIZE:
      return state;

    case propertyListActionTypes.SET_LIST: {
      const nextState = state.deleteIn(['list', 'payload']);
      return nextState.mergeDeep({
        list: {
          payload: formatPayload(get(action, 'payload.edges')),
          total: action.payload.totalCount,
        },
      });
    }

    case propertyListActionTypes.LIST_CS:
      return state.mergeDeep({
        communication: updateCommunicationObject(action.status, action.error),
      });

    default:
      return state;
  }
};

export default propertyListReducer;
